import { useViewContext } from "@folksam/ui/providers/ViewContext";
import React from "react";
import { SxStyleProp } from "theme-ui";

import { Box } from "../../cores";
import { useTableContext } from "../../providers";
import { FTable } from "../index";
import TableButton from "./TableButton";
import TableColumnCustom from "./TableColumnCustom";

export interface ITableColumn {
  sx?: SxStyleProp;
}
interface ITable {
  firstColumnSticky?: boolean;
  zebra?: boolean;
  separateColumns?: boolean;
  isMobile: boolean;
}
interface ITableHeaderColumn {
  sx?: SxStyleProp;
}

const Table: React.FC<ITable> & Statics = ({
  firstColumnSticky = true,
  zebra = true,
  separateColumns = true,
  children,
}) => {
  return (
    <FTable
      scrollable
      size="xs"
      zebra={zebra}
      separateColumns={separateColumns}
      firstColumnSticky={firstColumnSticky}
    >
      {children}
    </FTable>
  );
};
const TableCaption: React.FC = ({ children }) => {
  return (
    <FTable.Caption>
      <Box
        sx={{
          color: "text",
        }}
      >
        {children}
      </Box>
    </FTable.Caption>
  );
};

const TableHeader: React.FC = ({ children }) => {
  return <FTable.Header>{children}</FTable.Header>;
};

const TableHeaderColumn: React.FC<ITableHeaderColumn> = ({
  sx = {},
  children,
}) => {
  return (
    <FTable.HeaderColumn>
      <Box sx={{ height: "100%", ...sx }}>{children}</Box>
    </FTable.HeaderColumn>
  );
};

const TableBody: React.FC = ({ children }) => {
  return <FTable.Body>{children}</FTable.Body>;
};
const TableRow: React.FC = ({ children }) => {
  return <FTable.Row>{children}</FTable.Row>;
};

const TableColumn: React.FC<ITableColumn> = ({ children, sx = {} }) => {
  const { isMobile } = useViewContext();
  const { listView } = useTableContext();
  return (
    <FTable.Column>
      <Box
        sx={{
          ...sx,
          fontFamily: "serif",
          fontSize: 14,
          fontWeight: "inherit",
          paddingX: isMobile ? "xs" : "sm",
          paddingY: "xs",
          color: "inherit",
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace:
            isMobile || listView === "test_tabeller_kgos"
              ? "break-spaces"
              : "nowrap",
          margin: 0,
          height: "100%",
          textAlign: "center",
        }}
      >
        {children}
      </Box>
    </FTable.Column>
  );
};

type Statics = {
  Caption: typeof TableCaption;
  Header: typeof TableHeader;
  HeaderColumn: typeof TableHeaderColumn;
  Body: typeof TableBody;
  Row: typeof TableRow;
  Column: typeof TableColumn;
  ColumnCustom: typeof TableColumnCustom;
  Button: typeof TableButton;
};

Table.Caption = TableCaption;
Table.Header = TableHeader;
Table.HeaderColumn = TableHeaderColumn;
Table.Body = TableBody;
Table.Row = TableRow;
Table.Column = TableColumn;
Table.ColumnCustom = TableColumnCustom;
Table.Button = TableButton;

export default Table;
